const DownloadHeaderImg = () => {
  return (
    <svg
      width="382"
      height="61"
      viewBox="0 0 382 61"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 35L151 35"
        stroke="#09798D"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M230.735 35.5H380.735"
        stroke="#09798D"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <circle
        cx="106.5"
        cy="25.5"
        r="3"
        stroke="#F3A802"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <circle
        cx="141"
        cy="45"
        r="2"
        stroke="#500F71"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <circle
        cx="81"
        cy="17"
        r="2"
        stroke="#500F71"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <circle
        cx="3"
        cy="17"
        r="2"
        stroke="#500F71"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M142.963 16.2022C143.037 16.346 143.177 16.4445 143.338 16.4667L146.436 16.8943C146.436 16.8943 146.436 16.8943 146.436 16.8943C146.479 16.9003 146.491 16.9239 146.493 16.9303L146.499 16.9465C146.5 16.9505 146.501 16.955 146.499 16.961C146.497 16.9671 146.493 16.9757 146.484 16.9843L146.484 16.9844L144.242 19.056C144.117 19.1721 144.059 19.3442 144.09 19.5124L144.62 22.4363C144.62 22.4364 144.62 22.4364 144.62 22.4364C144.621 22.4451 144.619 22.4657 144.594 22.4835L144.593 22.4845C144.579 22.4941 144.563 22.5 144.541 22.5C144.532 22.5 144.515 22.4972 144.497 22.4884C144.497 22.4883 144.497 22.4883 144.497 22.4882L141.724 21.1031C141.584 21.0329 141.418 21.0328 141.278 21.1028L138.5 22.4858L138.499 22.4863C138.47 22.501 138.432 22.4992 138.402 22.4796C138.379 22.4621 138.377 22.4422 138.378 22.4336C138.378 22.4336 138.378 22.4336 138.378 22.4336L138.908 19.5096C138.939 19.3414 138.881 19.1693 138.756 19.0532L136.517 16.9839C136.507 16.9748 136.503 16.9659 136.501 16.9588C136.5 16.9526 136.499 16.946 136.501 16.9386C136.509 16.9198 136.529 16.8994 136.565 16.8943C136.565 16.8943 136.565 16.8943 136.565 16.8943L139.663 16.4695C139.824 16.4475 139.964 16.3489 140.039 16.205L141.426 13.5394C141.426 13.5394 141.426 13.5393 141.426 13.5393C141.435 13.5212 141.461 13.5 141.501 13.5C141.541 13.5 141.567 13.5218 141.577 13.5387L142.963 16.2022Z"
        stroke="#00B7D5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M95.9626 43.2022C96.0374 43.346 96.1772 43.4445 96.3377 43.4667L99.436 43.8943C99.4361 43.8943 99.4362 43.8943 99.4362 43.8943C99.4789 43.9003 99.4914 43.9239 99.4934 43.9303L99.4987 43.9465C99.5001 43.9505 99.5006 43.955 99.499 43.961C99.4974 43.9671 99.4934 43.9757 99.484 43.9843L99.484 43.9844L97.2425 46.056C97.117 46.1721 97.0594 46.3442 97.0899 46.5124L97.6198 49.4363C97.6198 49.4364 97.6198 49.4364 97.6198 49.4364C97.6214 49.4451 97.6194 49.4657 97.5943 49.4835L97.5929 49.4845C97.5794 49.4941 97.5629 49.5 97.5413 49.5C97.5321 49.5 97.5153 49.4972 97.4974 49.4884C97.4973 49.4883 97.4972 49.4883 97.4971 49.4882L94.724 48.1031C94.5835 48.0329 94.4183 48.0328 94.2777 48.1028L91.5005 49.4858L91.4994 49.4863C91.4701 49.501 91.4318 49.4992 91.4024 49.4796C91.3787 49.4621 91.3769 49.4422 91.3785 49.4336C91.3785 49.4336 91.3785 49.4336 91.3785 49.4336L91.9084 46.5096C91.9389 46.3414 91.8813 46.1693 91.7558 46.0532L89.5167 43.9839C89.5074 43.9748 89.5031 43.9659 89.5013 43.9588C89.4997 43.9526 89.4994 43.946 89.5014 43.9386C89.5091 43.9198 89.5287 43.8994 89.5649 43.8943C89.565 43.8943 89.565 43.8943 89.5651 43.8943L92.663 43.4695C92.8237 43.4475 92.9637 43.3489 93.0386 43.205L94.4256 40.5394C94.4256 40.5394 94.4256 40.5393 94.4256 40.5393C94.4351 40.5212 94.4606 40.5 94.5006 40.5C94.541 40.5 94.5673 40.5218 94.5767 40.5387L95.9626 43.2022Z"
        stroke="#00B7D5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <circle
        cx="41"
        cy="43"
        r="1.5"
        stroke="#F3A802"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <circle
        cx="62"
        cy="50"
        r="2"
        stroke="#500F71"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M46.9647 16.1403C47.0403 16.2823 47.1797 16.3793 47.3392 16.4009L50.4375 16.819C50.4376 16.819 50.4377 16.819 50.4378 16.819C50.4601 16.8221 50.4756 16.8303 50.4843 16.8373C50.4927 16.8439 50.4942 16.8486 50.4944 16.8494L50.4999 16.8657C50.5001 16.8662 50.5 16.8662 50.5 16.8659C50.5 16.8658 50.5 16.8663 50.4997 16.8675C50.4992 16.8696 50.4969 16.876 50.4881 16.8839L50.4881 16.8839L48.2466 18.9095C48.1178 19.0259 48.0586 19.2009 48.0902 19.3716L48.6201 22.2306C48.6202 22.2306 48.6202 22.2307 48.6202 22.2308C48.6204 22.2318 48.6206 22.2339 48.6187 22.2383C48.6165 22.2433 48.611 22.2521 48.5986 22.2607L48.5973 22.2616C48.5835 22.2712 48.5655 22.2778 48.5413 22.2778C48.5302 22.2778 48.5121 22.2746 48.4935 22.2656C48.4933 22.2656 48.4932 22.2655 48.4931 22.2654L45.72 20.9111C45.5817 20.8436 45.4201 20.8435 45.2817 20.9108L42.5045 22.2631L42.5034 22.2636C42.4711 22.2794 42.4289 22.2769 42.3982 22.2569C42.3868 22.2487 42.3817 22.2404 42.3796 22.2356C42.3776 22.2309 42.3779 22.2288 42.3781 22.2279L42.908 19.3689C42.9397 19.1982 42.8805 19.0232 42.7516 18.9068L40.5127 16.8834C40.5041 16.8753 40.5014 16.8685 40.5006 16.8654C40.5 16.8631 40.4997 16.8608 40.5004 16.8578C40.5062 16.8452 40.5235 16.8245 40.5634 16.819C40.5635 16.819 40.5635 16.819 40.5636 16.819L43.6615 16.4036C43.8212 16.3822 43.9608 16.2852 44.0364 16.143L45.4234 13.5367C45.4234 13.5366 45.4234 13.5366 45.4234 13.5366C45.4303 13.5238 45.4549 13.5 45.5006 13.5C45.5465 13.5 45.572 13.5241 45.5789 13.5361L46.9647 16.1403Z"
        stroke="#00B7D5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18.9647 43.1403C19.0403 43.2823 19.1797 43.3793 19.3392 43.4009L22.4375 43.819C22.4376 43.819 22.4377 43.819 22.4378 43.819C22.4601 43.8221 22.4756 43.8303 22.4843 43.8373C22.4927 43.8439 22.4942 43.8486 22.4944 43.8494L22.4999 43.8657C22.5001 43.8662 22.5 43.8662 22.5 43.8659C22.5 43.8658 22.5 43.8663 22.4997 43.8675C22.4992 43.8696 22.4969 43.876 22.4881 43.8839L22.4881 43.8839L20.2466 45.9095C20.1178 46.0259 20.0586 46.2009 20.0902 46.3716L20.6201 49.2306C20.6202 49.2306 20.6202 49.2307 20.6202 49.2308C20.6204 49.2318 20.6206 49.2339 20.6187 49.2383C20.6165 49.2433 20.611 49.2521 20.5986 49.2607L20.5973 49.2616C20.5835 49.2712 20.5655 49.2778 20.5413 49.2778C20.5302 49.2778 20.5121 49.2746 20.4935 49.2656C20.4933 49.2656 20.4932 49.2655 20.4931 49.2654L17.72 47.9111C17.5817 47.8436 17.4201 47.8435 17.2817 47.9108L14.5045 49.2631L14.5034 49.2636C14.4711 49.2794 14.4289 49.2769 14.3982 49.2569C14.3868 49.2487 14.3817 49.2404 14.3796 49.2356C14.3776 49.2309 14.3779 49.2288 14.3781 49.2279L14.908 46.3689C14.9397 46.1982 14.8805 46.0232 14.7516 45.9068L12.5127 43.8834C12.5041 43.8753 12.5014 43.8685 12.5006 43.8654C12.5 43.8631 12.4997 43.8608 12.5004 43.8578C12.5062 43.8452 12.5235 43.8245 12.5634 43.819C12.5635 43.819 12.5635 43.819 12.5636 43.819L15.6615 43.4036C15.8212 43.3822 15.9608 43.2852 16.0364 43.143L17.4234 40.5367C17.4234 40.5366 17.4234 40.5366 17.4234 40.5366C17.4303 40.5238 17.4549 40.5 17.5006 40.5C17.5465 40.5 17.572 40.5241 17.5789 40.5361L18.9647 43.1403Z"
        stroke="#00B7D5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M204.429 11H181.571C179.047 11 177 13.2002 177 15.9143V55.2286C177 57.9427 179.047 60.1429 181.571 60.1429H204.429C206.953 60.1429 209 57.9427 209 55.2286V15.9143C209 13.2002 206.953 11 204.429 11Z"
        stroke="#F3A802"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M193 51.8979H193.024"
        stroke="#F3A802"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M201 34.2383V37.7938C201 38.2653 200.813 38.7175 200.479 39.0509C200.146 39.3843 199.694 39.5716 199.222 39.5716H186.778C186.306 39.5716 185.854 39.3843 185.521 39.0509C185.187 38.7175 185 38.2653 185 37.7938V34.2383"
        stroke="#F3A802"
        stroke-width="0.8"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M188.556 29.7937L193 34.2381L197.445 29.7937"
        stroke="#F3A802"
        stroke-width="0.8"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M193 34.2382V23.5715"
        stroke="#F3A802"
        stroke-width="0.8"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <circle
        cx="362"
        cy="48"
        r="1.5"
        stroke="#F3A802"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <circle
        cx="347"
        cy="17"
        r="2"
        stroke="#500F71"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M374.965 16.1403C375.04 16.2823 375.18 16.3793 375.339 16.4009L378.438 16.819C378.438 16.819 378.438 16.819 378.438 16.819C378.46 16.8221 378.476 16.8303 378.484 16.8373C378.493 16.8439 378.494 16.8486 378.494 16.8494L378.5 16.8657C378.5 16.8662 378.5 16.8662 378.5 16.8659C378.5 16.8658 378.5 16.8663 378.5 16.8675C378.499 16.8696 378.497 16.876 378.488 16.8839L378.488 16.8839L376.247 18.9095C376.118 19.0259 376.059 19.2009 376.09 19.3716L376.62 22.2306C376.62 22.2306 376.62 22.2307 376.62 22.2308C376.62 22.2318 376.621 22.2339 376.619 22.2383C376.617 22.2433 376.611 22.2521 376.599 22.2607L376.597 22.2616C376.584 22.2712 376.565 22.2778 376.541 22.2778C376.53 22.2778 376.512 22.2746 376.493 22.2656C376.493 22.2656 376.493 22.2655 376.493 22.2654L373.72 20.9111C373.582 20.8436 373.42 20.8435 373.282 20.9108L370.504 22.2631L370.503 22.2636C370.471 22.2794 370.429 22.2769 370.398 22.2569C370.387 22.2487 370.382 22.2404 370.38 22.2356C370.378 22.2309 370.378 22.2288 370.378 22.2279L370.908 19.3689C370.94 19.1982 370.88 19.0232 370.752 18.9068L368.513 16.8834C368.504 16.8753 368.501 16.8685 368.501 16.8654C368.5 16.8631 368.5 16.8608 368.5 16.8578C368.506 16.8452 368.524 16.8245 368.563 16.819C368.563 16.819 368.564 16.819 368.564 16.819L371.661 16.4036C371.821 16.3822 371.961 16.2852 372.036 16.143L373.423 13.5367C373.423 13.5366 373.423 13.5366 373.423 13.5366C373.43 13.5238 373.455 13.5 373.501 13.5C373.547 13.5 373.572 13.5241 373.579 13.5361L374.965 16.1403Z"
        stroke="#00B7D5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M332.965 43.1403C333.04 43.2823 333.18 43.3793 333.339 43.4009L336.438 43.819C336.438 43.819 336.438 43.819 336.438 43.819C336.46 43.8221 336.476 43.8303 336.484 43.8373C336.493 43.8439 336.494 43.8486 336.494 43.8494L336.5 43.8657C336.5 43.8662 336.5 43.8662 336.5 43.8659C336.5 43.8658 336.5 43.8663 336.5 43.8675C336.499 43.8696 336.497 43.876 336.488 43.8839L336.488 43.8839L334.247 45.9095C334.118 46.0259 334.059 46.2009 334.09 46.3716L334.62 49.2306C334.62 49.2306 334.62 49.2307 334.62 49.2308C334.62 49.2318 334.621 49.2339 334.619 49.2383C334.617 49.2433 334.611 49.2521 334.599 49.2607L334.597 49.2616C334.584 49.2712 334.565 49.2778 334.541 49.2778C334.53 49.2778 334.512 49.2746 334.493 49.2656C334.493 49.2656 334.493 49.2655 334.493 49.2654L331.72 47.9111C331.582 47.8436 331.42 47.8435 331.282 47.9108L328.504 49.2631L328.503 49.2636C328.471 49.2794 328.429 49.2769 328.398 49.2569C328.387 49.2487 328.382 49.2404 328.38 49.2356C328.378 49.2309 328.378 49.2288 328.378 49.2279L328.908 46.3689C328.94 46.1982 328.88 46.0232 328.752 45.9068L326.513 43.8834C326.504 43.8753 326.501 43.8685 326.501 43.8654C326.5 43.8631 326.5 43.8608 326.5 43.8578C326.506 43.8452 326.524 43.8245 326.563 43.819C326.563 43.819 326.564 43.819 326.564 43.819L329.661 43.4036C329.821 43.3822 329.961 43.2852 330.036 43.143L331.423 40.5367C331.423 40.5366 331.423 40.5366 331.423 40.5366C331.43 40.5238 331.455 40.5 331.501 40.5C331.547 40.5 331.572 40.5241 331.579 40.5361L332.965 43.1403Z"
        stroke="#00B7D5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <circle
        cx="274"
        cy="25"
        r="2.5"
        stroke="#F3A802"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <circle
        cx="297"
        cy="43"
        r="2"
        stroke="#500F71"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <circle
        cx="239"
        cy="17"
        r="2"
        stroke="#500F71"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M310.963 16.2022C311.037 16.346 311.177 16.4445 311.338 16.4667L314.436 16.8943C314.436 16.8943 314.436 16.8943 314.436 16.8943C314.479 16.9003 314.491 16.9239 314.493 16.9303L314.499 16.9465C314.5 16.9505 314.501 16.955 314.499 16.961C314.497 16.9671 314.493 16.9757 314.484 16.9843L314.484 16.9844L312.242 19.056C312.117 19.1721 312.059 19.3442 312.09 19.5124L312.62 22.4363C312.62 22.4364 312.62 22.4364 312.62 22.4364C312.621 22.4451 312.619 22.4657 312.594 22.4835L312.593 22.4845C312.579 22.4941 312.563 22.5 312.541 22.5C312.532 22.5 312.515 22.4972 312.497 22.4884C312.497 22.4883 312.497 22.4883 312.497 22.4882L309.724 21.1031C309.584 21.0329 309.418 21.0328 309.278 21.1028L306.5 22.4858L306.499 22.4863C306.47 22.501 306.432 22.4992 306.402 22.4796C306.379 22.4621 306.377 22.4422 306.378 22.4336C306.378 22.4336 306.378 22.4336 306.378 22.4336L306.908 19.5096C306.939 19.3414 306.881 19.1693 306.756 19.0532L304.517 16.9839C304.507 16.9748 304.503 16.9659 304.501 16.9588C304.5 16.9526 304.499 16.946 304.501 16.9386C304.509 16.9198 304.529 16.8994 304.565 16.8943C304.565 16.8943 304.565 16.8943 304.565 16.8943L307.663 16.4695C307.824 16.4475 307.964 16.3489 308.039 16.205L309.426 13.5394C309.426 13.5394 309.426 13.5393 309.426 13.5393C309.435 13.5212 309.461 13.5 309.501 13.5C309.541 13.5 309.567 13.5218 309.577 13.5387L310.963 16.2022Z"
        stroke="#00B7D5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M253.963 43.2022C254.037 43.346 254.177 43.4445 254.338 43.4667L257.436 43.8943C257.436 43.8943 257.436 43.8943 257.436 43.8943C257.479 43.9003 257.491 43.9239 257.493 43.9303L257.499 43.9465C257.5 43.9505 257.501 43.955 257.499 43.961C257.497 43.9671 257.493 43.9757 257.484 43.9843L257.484 43.9844L255.242 46.056C255.117 46.1721 255.059 46.3442 255.09 46.5124L255.62 49.4363C255.62 49.4364 255.62 49.4364 255.62 49.4364C255.621 49.4451 255.619 49.4657 255.594 49.4835L255.593 49.4845C255.579 49.4941 255.563 49.5 255.541 49.5C255.532 49.5 255.515 49.4972 255.497 49.4884C255.497 49.4883 255.497 49.4883 255.497 49.4882L252.724 48.1031C252.584 48.0329 252.418 48.0328 252.278 48.1028L249.5 49.4858L249.499 49.4863C249.47 49.501 249.432 49.4992 249.402 49.4796C249.379 49.4621 249.377 49.4422 249.378 49.4336C249.378 49.4336 249.378 49.4336 249.378 49.4336L249.908 46.5096C249.939 46.3414 249.881 46.1693 249.756 46.0532L247.517 43.9839C247.507 43.9748 247.503 43.9659 247.501 43.9588C247.5 43.9526 247.499 43.946 247.501 43.9386C247.509 43.9198 247.529 43.8994 247.565 43.8943C247.565 43.8943 247.565 43.8943 247.565 43.8943L250.663 43.4695C250.824 43.4475 250.964 43.3489 251.039 43.205L252.426 40.5394C252.426 40.5394 252.426 40.5393 252.426 40.5393C252.435 40.5212 252.461 40.5 252.501 40.5C252.541 40.5 252.567 40.5218 252.577 40.5387L253.963 43.2022Z"
        stroke="#00B7D5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default DownloadHeaderImg;
